import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7efe85be")

_pushScopeId("data-v-7efe85be")
const _hoisted_1 = { class: "software_recommend" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "recommend_title" }, "安装可牛产品，纯净办公，效率翻倍", -1)
const _hoisted_3 = { class: "flex_start_center" }
const _hoisted_4 = { class: "recommend_bottom flex_centers" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("ul", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viewModel.softwareList, (item, idx) => {
        return (_openBlock(), _createBlock("li", {
          key: idx,
          class: "flex_start_center"
        }, [
          _createVNode("i", {
            class: item.iconClass
          }, null, 2),
          _createVNode("div", null, [
            _createVNode("div", null, _toDisplayString(item.label), 1),
            _createVNode("span", null, _toDisplayString(item.desc), 1)
          ])
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("span", {
        class: "watch_detail",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openWebsite && _ctx.openWebsite(...args)))
      }, "查看详情")
    ])
  ]))
})